"use strict";

var _taggedTemplateLiteral = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HR = void 0;

var styled_components_1 = __importDefault(require("styled-components"));

var theme_1 = require("../theme");

exports.HR = styled_components_1.default.hr(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin: 1.5em 0;\n  border: 1px solid ", ";\n"])), theme_1.theme.colors.white[600]);